export const numberMethod = (e) => {
    const re = /[0-9 +-]+/g;
    if (!re.test(e.key)) {
        e.preventDefault();
    }
  };